import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import config from '../config/config';
import { deleteExtraColor, onaddExtraColor, onUpdateExtraColor, onchangeChatIcon, handleCompanyLogo, handleCompanyLogoRemove } from '../features/appSlice';
import InputColorField from '../ui/colorPicker/InputColorField';
import ChatBotWeb from './chatbotpreview/ChatBotWeb';

const EditLogo = ({ isWhiteLable }) => {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const updateColor = (e, name) => {
        if (name.includes('_')) {
            const nameArray = name.split('_');
            dispatch(onUpdateExtraColor([...nameArray, e.hex]));
        } else {
            dispatch(onUpdateExtraColor([name, e.hex]));
        }

    }

    const updateColorFromInput = (v, name) => {
        if (name.includes('_')) {
            const nameArray = name.split('_');
            dispatch(onUpdateExtraColor([...nameArray, v]));
        } else {
            dispatch(onUpdateExtraColor([name, v]));
        }
    }

    const changeChatIcon = (img, id) => {
        dispatch(onchangeChatIcon(img));
    }



    return (
        <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">

            <div className='row'>
                <div className='col-md-12'>
                    <h2 className='box-title'>Design</h2>
                </div>
                <div className='col-md-4'>
                    <div className='row'>
                        <form id='editlogoform'>
                            <div className="form-group" style={{ marginBottom: 15 }}>
                                <label style={{ fontWeight: 600 }}>Select a Chat Icon</label>
                                <div className="chat-image-box">
                                    <label
                                        className="image-checkbox"
                                        onClick={(e) =>
                                            changeChatIcon("img-icon1-white.png", "icon1")
                                        }
                                        style={
                                            state.app.contextData.selectedTheme == "img-icon1-white.png"
                                                ? {
                                                    backgroundImage:
                                                        "linear-gradient(45deg," +
                                                        state.app.contextData.primaryColor +
                                                        "," +
                                                        state.app.contextData.secondaryColor +
                                                        ")",
                                                }
                                                : { backgroundImage: "unset" }
                                        }
                                    >
                                        <img
                                            className="img-responsive"
                                            id="icon1"
                                            src={
                                                state.app.contextData.selectedTheme == "img-icon1-white.png"
                                                    ? `${process.env.PUBLIC_URL}/images/logos/` + state.app.contextData.selectedTheme
                                                    : `${process.env.PUBLIC_URL}/images/logos/chat-icon-1.png`
                                            }
                                            alt=""
                                        />
                                    </label>
                                    <label
                                        className="image-checkbox"
                                        onClick={(e) =>
                                            changeChatIcon("img-icon2-white.png", "icon2")
                                        }
                                        style={
                                            state.app.contextData.selectedTheme == "img-icon2-white.png"
                                                ? {
                                                    backgroundImage:
                                                        "linear-gradient(45deg," +
                                                        state.app.contextData.primaryColor +
                                                        "," +
                                                        state.app.contextData.secondaryColor +
                                                        ")",
                                                }
                                                : { backgroundImage: "unset" }
                                        }
                                    >
                                        <img
                                            className="img-responsive"
                                            id="icon1"
                                            src={
                                                state.app.contextData.selectedTheme == "img-icon2-white.png"
                                                    ? `${process.env.PUBLIC_URL}/images/logos/` + state.app.contextData.selectedTheme
                                                    : `${process.env.PUBLIC_URL}/images/logos/chat-icon-2.png`
                                            }
                                            alt=""
                                        />
                                    </label>
                                    <label
                                        className="image-checkbox"
                                        onClick={(e) =>
                                            changeChatIcon("img-icon3-white.png", "icon3")
                                        }
                                        style={
                                            state.app.contextData.selectedTheme == "img-icon3-white.png"
                                                ? {
                                                    backgroundImage:
                                                        "linear-gradient(45deg," +
                                                        state.app.contextData.primaryColor +
                                                        "," +
                                                        state.app.contextData.secondaryColor +
                                                        ")",
                                                }
                                                : { backgroundImage: "unset" }
                                        }
                                    >
                                        <img
                                            className="img-responsive"
                                            id="icon1"
                                            src={
                                                state.app.contextData.selectedTheme == "img-icon3-white.png"
                                                    ? `${process.env.PUBLIC_URL}/images/logos/` + state.app.contextData.selectedTheme
                                                    : `${process.env.PUBLIC_URL}/images/logos/chat-icon-3.png`
                                            }
                                            alt=""
                                        />
                                    </label>
                                    <label
                                        className="image-checkbox"
                                        onClick={(e) =>
                                            changeChatIcon("img-icon4-white.png", "icon1")
                                        }
                                        style={
                                            state.app.contextData.selectedTheme == "img-icon4-white.png"
                                                ? {
                                                    backgroundImage:
                                                        "linear-gradient(45deg," +
                                                        state.app.contextData.primaryColor +
                                                        "," +
                                                        state.app.contextData.secondaryColor +
                                                        ")",
                                                }
                                                : { backgroundImage: "unset" }
                                        }
                                    >
                                        <img
                                            className="img-responsive"
                                            id="icon1"
                                            src={
                                                state.app.contextData.selectedTheme == "img-icon4-white.png"
                                                    ? `${process.env.PUBLIC_URL}/images/logos/` + state.app.contextData.selectedTheme
                                                    : `${process.env.PUBLIC_URL}/images/logos/chat-icon-4.png`
                                            }
                                            alt=""
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className='form-group'>
                                <label style={{ fontWeight: 600 }}>Company logo (ideally a square logo)</label>
                                <div className="logo-img">
                                    {isWhiteLable ?
                                        <img
                                            src={
                                                state.app.contextData.companyLogo == ""

                                                    ? `${process.env.PUBLIC_URL}/images/whitelablechaticon.jpg`
                                                    : (state.app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${state.app.contextData.companyLogo}` : `${state.app.contextData.companyLogo}`)
                                            }
                                            alt=""
                                        /> :
                                        <img
                                            src={
                                                state.app.contextData.companyLogo == ""

                                                    ? `${process.env.PUBLIC_URL}/images/fevicon_icon_blue.png`
                                                    : (state.app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${state.app.contextData.companyLogo}` : `${state.app.contextData.companyLogo}`)
                                            }
                                            alt=""
                                        />
                                    }
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div className="upload-btn-wrapper">
                                        <button style={isWhiteLable ? {
                                            backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                            color: state.app.contextData?.buttonTextColor, height: 38
                                        } : { height: 38, textAlign: 'center', fontSize: 15, padding: 8 }}
                                            className={`main_btns linear-gradient width-100 ${isWhiteLable ? 'white-label' : ''}`}

                                        // className="btn linear-gradient zy-save-btn width-100"
                                        >Edit Logo</button>
                                        <input
                                            type="file"
                                            name="companyLogo"
                                            id="comanyLogoId"
                                            accept="image/jpg,image/png,image/jpeg,image/gif"
                                            onChange={(e) => dispatch(handleCompanyLogo(e))}
                                        />
                                    </div>
                                    {state.app.contextData.companyLogo &&
                                        <button
                                            type="reset"
                                            className="btn linear-gradient-cancel zy-cancel-btn ml-2"
                                            onClick={() => dispatch(handleCompanyLogoRemove())}
                                        >Remove</button>
                                    }
                                </div>
                            </div>
                        </form>
                        <div className="form-group">
                            <label>Header Color</label>
                            {state.app.contextData.buttonHeaderColor &&
                                state.app.contextData.buttonHeaderColor.map((x, y) => {
                                    return (
                                        <div key={y} style={{ display: "flex" }}>
                                            <InputColorField
                                                name={"buttonHeaderColor_" + y}
                                                value={x}
                                                onchangeColor={updateColor}
                                                onChangeFromInput={updateColorFromInput}
                                            />
                                            {y != 0 && (
                                                <a
                                                    onClick={(e) => dispatch(deleteExtraColor([y, "header"]))}
                                                    title="Delete"
                                                    // className="btn btn-icon gray"
                                                    style={{ marginRight: -39 }}
                                                >
                                                    <i className="fa fa-trash fa-sm text-danger ml-2"></i>
                                                </a>
                                            )}
                                        </div>
                                    );
                                })}
                            <span
                                className="add-gradient"
                                onClick={() => dispatch(onaddExtraColor('header'))}
                            >
                                +Add Gradient
                            </span>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <label style={{ fontWeight: 600 }}>Chat Icon Color</label>
                    <div className="form-group" style={{ marginBottom: 10 }}>
                        <label>Primary</label>
                        <InputColorField
                            name="primaryColor"
                            value={state.app.contextData.primaryColor}
                            onchangeColor={updateColor}
                            onChangeFromInput={updateColorFromInput}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: 10 }}>
                        <label>Secondary</label>
                        <InputColorField
                            name="secondaryColor"
                            value={state.app.contextData.secondaryColor}
                            onchangeColor={updateColor}
                            onChangeFromInput={updateColorFromInput}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: 10 }}>
                        <label>Button Color</label>
                        {state.app.contextData.buttonColor &&
                            state.app.contextData.buttonColor.map((x, y) => {
                                return (
                                    <div key={y} style={{ display: "flex" }}>
                                        <InputColorField
                                            name={"buttonColor_" + y}
                                            value={x}
                                            onchangeColor={updateColor}
                                            onChangeFromInput={updateColorFromInput}
                                        />
                                        {y != 0 && (
                                            <a
                                                onClick={(e) => dispatch(deleteExtraColor([y, "button"]))}
                                                title="Delete"
                                                // className="btn btn-icon gray"
                                                style={{ marginRight: -39 }}
                                            >
                                                <i className="fa fa-trash fa-sm text-danger ml-2"></i>
                                            </a>
                                        )}
                                    </div>
                                );
                            })}
                        <span
                            className="add-gradient"
                            onClick={() => dispatch(onaddExtraColor('button'))}
                        >
                            +Add Gradient
                        </span>
                    </div>
                    <div className="form-group" style={{ marginBottom: 10 }}>
                        <label>Button Text Color</label>
                        <InputColorField
                            name="buttonTextColor"
                            value={state.app.contextData.buttonTextColor}
                            onchangeColor={updateColor}
                            onChangeFromInput={updateColorFromInput}
                        />
                    </div>
                </div>
                <div className='col-md-4 chatpre'>
                    <label style={{ fontWeight: 600 }}>Preview size is smaller than actual size. Scroll down for a true preview.</label>
                    {state &&
                        <ChatBotWeb isWhiteLable={isWhiteLable} />
                    }
                </div>
            </div>
        </div>
    )
}

export default EditLogo;